import { useEffect, useRef, useState } from 'react';
import { ApiError } from '../api/client';
import { useAuth } from './AuthContext';
import { renderGoogleButton } from './googleIdentity';

/**
 * Accesso alla sola Google SSO: email/password (login e registrazione) sono
 * disattivati lato server via PASSWORD_AUTH_ENABLED — questa UI riflette
 * quello stato invece di mostrare un form che risponderebbe sempre 403.
 * Riattivarli in futuro e' ripristinare questo file (login/register restano
 * intatti in AuthContext).
 */
export function AuthScreen() {
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const googleButtonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = googleButtonRef.current;
    if (!container) return;
    void renderGoogleButton(container, async (credential) => {
      setError(null);
      setBusy(true);
      try {
        await loginWithGoogle(credential);
      } catch (err) {
        setError(err instanceof ApiError ? err.message : 'Qualcosa è andato storto');
      } finally {
        setBusy(false);
      }
    });
  }, [loginWithGoogle]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg px-5 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <img src="/icon.svg" alt="" className="mx-auto mb-4 h-14 w-14" />
          <h1 className="text-2xl font-semibold tracking-tight">ExpenseMonitor</h1>
          <p className="mt-1 text-sm text-muted">Spese e risparmi, senza foglio di calcolo</p>
        </div>

        {error && (
          <p
            role="alert"
            className="mb-4 rounded-[var(--radius-control)] bg-danger-soft px-3 py-2 text-sm text-danger"
          >
            {error}
          </p>
        )}

        <div
          ref={googleButtonRef}
          aria-busy={busy}
          className="flex justify-center rounded-[var(--radius-card)] bg-surface p-4"
        />
      </div>
    </div>
  );
}
